<div *ngIf="(imageURL || initialImageURL)" class="uploaded-image-container">
    <img class="image-preview" [src]="imageURL ? imageURL : initialImageURL">
</div>
<br>
<input type="file" accept=".png, .jpg, .jpeg" (change)="uploadFile($event.target.files)">